import { Button } from '@/components/button';
import { GameIcon } from '@/components/GameIcon';
import type { Tournament } from '@/types/tournament';
import { cn } from '@/utils/cn';
import { getTournamentPath } from '@/utils/paths';
import { PastTournamentBadge } from './PastTournamentBadge';

export function PastTournamentCard({
  tournament,
  className,
}: {
  tournament: Tournament;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'relative h-[254px]',
        'overflow-hidden rounded-md',
        className
      )}
    >
      <div
        className={cn(
          'absolute inset-0 z-2',
          'px-5 pt-3 pb-4',
          'flex flex-col justify-between'
        )}
      >
        <div className="flex justify-end">
          <PastTournamentBadge />
        </div>
        <div className="flex flex-col items-center">
          <GameIcon className="mb-4 size-8" game={tournament.game} />
          <div className="mb-2 text-gray text-sm">Special event available</div>
          <h3 className="text-center font-semibold text-3xl">
            {tournament.name}
          </h3>
        </div>
        <div>
          <Button
            as="link"
            href={getTournamentPath({
              slug: tournament.slug,
              game: tournament.game,
            })}
            size="lg"
            variant="outlineWithBg"
          >
            Make your picks
          </Button>
        </div>
      </div>
      <div className='absolute inset-0 z-1 bg-[url("/tournaments/tournaments_banner.webp")] bg-center bg-size-[180%] opacity-50' />
    </div>
  );
}
